<template>
    <v-dialog v-model="dialog" max-width="800">
        <v-card class="pa-5">
            <div class="d-flex align-center font-weight-medium mb-4">
                <div>
                    Configure Opsgenie integration
                    <a :href="`https://coroot.com/docs/coroot-community-edition/alerting/opsgenie`" target="_blank">
                        <v-icon>mdi-information-outline</v-icon>
                    </a>
                    <v-progress-circular v-if="loading" indeterminate color="green" size="30" />
                </div>
                <v-spacer />
                <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <v-form ref="form" v-model="valid" :disabled="value === 'del'">
                <div class="subtitle-1">To configure an <b>Rest HTTP API</b> integration in your Opsgenie account:</div>
                <ol class="mb-4 caption">
                    <li>Navigate to the <b>Teams</b> page</li>
                    <li>Choose a team (or create a new one)</li>
                    <li>Go to <b>Integrations</b> &rarr; <b>Add integration</b> and create an <b>API</b> integration</li>
                    <li>Change the <b>Name</b>, if necessary (e.g. <i>Coroot</i>)</li>
                    <li>Adjust permissions (Coroot requires only <b>Create and Update Access</b>)</li>
                    <li>Press <b>Save Integration</b></li>
                    <li>Copy the <b>API Key</b> and paste it below</li>
                </ol>

                <div class="subtitle-1">API Key</div>
                <div class="d-flex">
                    <!-- eslint-disable-next-line vue/no-mutating-props -->
                    <v-text-field v-model="integration.opsgenie.api_key" outlined dense :rules="[$validators.notEmpty]"/>
                    <!-- eslint-disable-next-line vue/no-mutating-props -->
                    <v-checkbox v-model="integration.opsgenie.eu_instance" label="EU instance of Opsgenie" dense hide-details class="ml-3"/>
                </div>

                <v-checkbox v-model="integration.default_for_incidents" label="Default for alerting" dense hide-details />

                <v-alert v-if="error" color="red" icon="mdi-alert-octagon-outline" outlined text class="my-4">
                    {{error}}
                </v-alert>
                <v-alert v-if="message" color="green" outlined text class="my-4">
                    {{message}}
                </v-alert>
                <div class="d-flex align-center">
                    <v-spacer />
                    <v-btn v-if="value === 'del'" @click="del()" color="error">Delete</v-btn>
                    <template v-else>
                        <v-btn @click="test()" color="secondary" :disabled="!valid" class="mr-4">Send test alert</v-btn>
                        <v-btn @click="save()" color="primary" :disabled="!valid">Save</v-btn>
                    </template>
                </div>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    props: {
        value: String,
        integration: Object,
    },

    data() {
        return {
            dialog: !!this.value,
            loading: false,
            error: '',
            message: '',
            valid: false,
        };
    },

    watch: {
        dialog(v) {
            this.$emit('input', v ? this.value : '');
        },
    },

    methods: {
        save() {
            this.loading = true;
            this.error = '';
            this.message = '';
            this.$api.saveIntegration(this.integration, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                this.message = 'Settings were successfully updated.';
                setTimeout(() => {
                    this.message = '';
                    this.dialog = false;
                }, 1000);
            });
        },
        del() {
            this.loading = true;
            this.error = '';
            this.message = '';
            this.$api.delIntegration(this.integration, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                this.dialog = false;
            });
        },
        test() {
            this.loading = true;
            this.error = '';
            this.message = '';
            this.$api.testIntegration(this.integration, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                this.message = 'A test alert has been successfully sent.';
                setTimeout(() => {
                    this.message = '';
                }, 3000);
            });
        },
    },
}
</script>

<style scoped>

</style>